export default class LoginId {
  public static of(value: string): LoginId {
    return new LoginId(value);
  }
  public static empty(): LoginId {
    return LoginId.of("");
  }

  private readonly _value: string = "";

  constructor(value: string) {
    this._value = value;
  }

  public isEmpty(): boolean {
    return !this._value;
  }

  get value() {
    return this.isEmpty() ? "" : this._value;
  }
}